import { Component, Input } from '@angular/core';
import { SubscriptionTypes } from '@app/core/models/input/company/company-parameters.model';
import { CompanyDataAdmin } from '@app/core/models/input/company/company.model';

@Component({
    selector: 'app-header-company',
    templateUrl: './header-company.component.html',
    styleUrls: ['./header-company.component.scss'],
    standalone: false
})
export class HeaderCompanyComponent {
  @Input() companyData?: CompanyDataAdmin;
  @Input() subscriptionTypes?: SubscriptionTypes[];


}
